import { Box, styled, Tooltip, type TooltipProps, Typography } from '@mui/material';

export const HoverCard = styled(({ className, ...props }: TooltipProps) => (
  // Box is necessary because a tooltip needs an anchorable element to work
  <Tooltip {...props} classes={{ popper: className }}>
    <Box>{props.children}</Box>
  </Tooltip>
))({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: '#fff',
    color: 'black',
    maxWidth: 'none',
    minWidth: 270,
    fontSize: 14,
    borderRadius: 8,
    boxShadow: '0px 3px 5px 2px rgba(0,0,0,0.3)',
  },
  [`& .MuiTooltip-arrow`]: {
    color: '#fff',
  },
});

type TooltipElementProps = {
  readonly label: string;
  readonly value: string | number;
  readonly paddingLeft?: string | number;
};

export const TooltipElement = ({ label, value, paddingLeft }: TooltipElementProps) => (
  <Typography variant="labelLight" display="flex" pl={paddingLeft}>
    {label !== '' && <Box sx={{ color: 'text.secondary', mr: 1 }}>{label}</Box>}
    {value !== '' && <Box sx={{ whiteSpace: 'pre-wrap' }}>{value}</Box>}
  </Typography>
);
